import React from 'react';
import CircleButton from '../../shared/CircleButton';
import redoIcon from '../../../../assets/images/icons/trail/rotate-right-green.svg';
import undoIcon from '../../../../assets/images/icons/trail/rotate-left-green.svg';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';

const UndoRedoControls = ({ handleUndoClick, handleRedoClick }) => {
  return (
    <>
      <CircleButton icon={undoIcon} onClick={wrapEventHandler(handleUndoClick)} title={StringConstantsMixin.strings.TRACK_DETAIL.UNDO} />
      <CircleButton icon={redoIcon} onClick={wrapEventHandler(handleRedoClick)} title={StringConstantsMixin.strings.TRACK_DETAIL.REDO} />
    </>
  );
};

export default UndoRedoControls;
